export const FALLBACK_LANGUAGE_SCHEMA = [
  {
    LanguageCode: 'AFRIK',
    LanguageName: 'Afrikaans',
  },
  {
    LanguageCode: 'ALBAN',
    LanguageName: 'Albanian',
  },
  {
    LanguageCode: 'AMHAR',
    LanguageName: 'Amharic',
  },
  {
    LanguageCode: 'ARABI',
    LanguageName: 'Arabic',
  },
  {
    LanguageCode: 'ARMEN',
    LanguageName: 'Armenian',
  },
  {
    LanguageCode: 'ASSAM',
    LanguageName: 'Assamese',
  },
  {
    LanguageCode: 'ASSYR',
    LanguageName: 'Assyrian',
  },
  {
    LanguageCode: 'BASQU',
    LanguageName: 'Basque',
  },
  {
    LanguageCode: 'BYELO',
    LanguageName: 'Belarusian',
  },
  {
    LanguageCode: 'BENGA',
    LanguageName: 'Bengali (alt Bangla)',
  },
  {
    LanguageCode: 'BISLA',
    LanguageName: 'Bislama',
  },
  {
    LanguageCode: 'BOSNI',
    LanguageName: 'Bosnian',
  },
  {
    LanguageCode: 'BULGA',
    LanguageName: 'Bulgarian',
  },
  {
    LanguageCode: 'CANTO',
    LanguageName: 'Cantonese',
  },
  {
    LanguageCode: 'CATAL',
    LanguageName: 'Catalan',
  },
  {
    LanguageCode: 'CHICH',
    LanguageName: 'Chichewa (alt Chewa/Chinyanja/Nyanja)',
  },
  {
    LanguageCode: 'CHINE',
    LanguageName: 'Chinese',
  },
  {
    LanguageCode: 'CONGO',
    LanguageName: 'Congo Swahili',
  },
  {
    LanguageCode: 'RAROT',
    LanguageName: 'Cook Islands Maori (alt Rarotongan)',
  },
  {
    LanguageCode: 'CROAT',
    LanguageName: 'Croatian',
  },
  {
    LanguageCode: 'CZECH',
    LanguageName: 'Czech',
  },
  {
    LanguageCode: 'DANIS',
    LanguageName: 'Danish',
  },
  {
    LanguageCode: 'DARI',
    LanguageName: 'Dari',
  },
  {
    LanguageCode: 'DINKA',
    LanguageName: 'Dinka',
  },
  {
    LanguageCode: 'DUTCH',
    LanguageName: 'Dutch',
  },
  {
    LanguageCode: 'DZONG',
    LanguageName: 'Dzongkha',
  },
  {
    LanguageCode: 'ESTON',
    LanguageName: 'Estonian',
  },
  {
    LanguageCode: 'FARSI',
    LanguageName: 'Farsi (alt Persian)',
  },
  {
    LanguageCode: 'FIJIH',
    LanguageName: 'Fiji Hindi',
  },
  {
    LanguageCode: 'FIJIA',
    LanguageName: 'Fijian',
  },
  {
    LanguageCode: 'FILIP',
    LanguageName: 'Filipino (alt Tagalog)',
  },
  {
    LanguageCode: 'FINNI',
    LanguageName: 'Finnish',
  },
  {
    LanguageCode: 'FRENC',
    LanguageName: 'French',
  },
  {
    LanguageCode: 'GALIC',
    LanguageName: 'Galician',
  },
  {
    LanguageCode: 'GEORG',
    LanguageName: 'Georgian',
  },
  {
    LanguageCode: 'GERMA',
    LanguageName: 'German',
  },
  {
    LanguageCode: 'GREEK',
    LanguageName: 'Greek',
  },
  {
    LanguageCode: 'GUJAR',
    LanguageName: 'Gujarati',
  },
  {
    LanguageCode: 'HAITI',
    LanguageName: 'Haitian Creole',
  },
  {
    LanguageCode: 'HAKKA',
    LanguageName: 'Hakka Chinese',
  },
  {
    LanguageCode: 'HAUSA',
    LanguageName: 'Hausa',
  },
  {
    LanguageCode: 'HAZAR',
    LanguageName: 'Hazaragi',
  },
  {
    LanguageCode: 'HEBRE',
    LanguageName: 'Hebrew',
  },
  {
    LanguageCode: 'HINDI',
    LanguageName: 'Hindi',
  },
  {
    LanguageCode: 'HUNGA',
    LanguageName: 'Hungarian',
  },
  {
    LanguageCode: 'ICELA',
    LanguageName: 'Icelandic',
  },
  {
    LanguageCode: 'IGBO',
    LanguageName: 'Igbo (alt Ibo)',
  },
  {
    LanguageCode: 'INDON',
    LanguageName: 'Indonesian',
  },
  {
    LanguageCode: 'IRISH',
    LanguageName: 'Irish',
  },
  {
    LanguageCode: 'ITALI',
    LanguageName: 'Italian',
  },
  {
    LanguageCode: 'JAPAN',
    LanguageName: 'Japanese',
  },
  {
    LanguageCode: 'KANNA',
    LanguageName: 'Kannada (alt Kanarese)',
  },
  {
    LanguageCode: 'KAZAK',
    LanguageName: 'Kazakh',
  },
  {
    LanguageCode: 'KHMER',
    LanguageName: 'Khmer',
  },
  {
    LanguageCode: 'KINYA',
    LanguageName: 'Kinyarwanda',
  },
  {
    LanguageCode: 'KIRUN',
    LanguageName: 'Kirundi (alt Rundi/Urundi)',
  },
  {
    LanguageCode: 'KOREA',
    LanguageName: 'Korean',
  },
  {
    LanguageCode: 'KURDI',
    LanguageName: 'Kurmanji Kurdish (alt Northern Kurdish/Ezdiki)',
  },
  {
    LanguageCode: 'KIRGH',
    LanguageName: 'Kyrgyz (alt Kirghiz)',
  },
  {
    LanguageCode: 'LAO',
    LanguageName: 'Lao',
  },
  {
    LanguageCode: 'LATIN',
    LanguageName: 'Latin',
  },
  {
    LanguageCode: 'LATVI',
    LanguageName: 'Latvian',
  },
  {
    LanguageCode: 'LINGA',
    LanguageName: 'Lingala',
  },
  {
    LanguageCode: 'LITHU',
    LanguageName: 'Lithuanian',
  },
  {
    LanguageCode: 'MACED',
    LanguageName: 'Macedonian',
  },
  {
    LanguageCode: 'MALAY',
    LanguageName: 'Malay (alt Melayu)',
  },
  {
    LanguageCode: 'MALA',
    LanguageName: 'Malayalam',
  },
  {
    LanguageCode: 'DIVEH',
    LanguageName: 'Maldivian (alt Dhivehi/Divehli)',
  },
  {
    LanguageCode: 'MALTE',
    LanguageName: 'Maltese',
  },
  {
    LanguageCode: 'MAORI',
    LanguageName: 'Maori',
  },
  {
    LanguageCode: 'MARAT',
    LanguageName: 'Marathi',
  },
  {
    LanguageCode: 'MONGO',
    LanguageName: 'Mongolian',
  },
  {
    LanguageCode: 'BURME',
    LanguageName: 'Myanmar Language (alt Burmese)',
  },
  {
    LanguageCode: 'NEPAL',
    LanguageName: 'Nepali',
  },
  {
    LanguageCode: 'AZERB',
    LanguageName: 'North Azerbaijani',
  },
  {
    LanguageCode: 'PEDI',
    LanguageName: 'Northern Sotho (alt Pedi)',
  },
  {
    LanguageCode: 'NORWE',
    LanguageName: 'Norwegian',
  },
  {
    LanguageCode: 'ORIYA',
    LanguageName: 'Odia (alt Oriya)',
  },
  {
    LanguageCode: 'OROMO',
    LanguageName: 'Oromo',
  },
  {
    LanguageCode: 'PASHT',
    LanguageName: 'Pashto',
  },
  {
    LanguageCode: 'POLIS',
    LanguageName: 'Polish',
  },
  {
    LanguageCode: 'PORTU',
    LanguageName: 'Portuguese',
  },
  {
    LanguageCode: 'PUNJA',
    LanguageName: 'Punjabi',
  },
  {
    LanguageCode: 'ROHIB',
    LanguageName: 'Rohingya',
  },
  {
    LanguageCode: 'ROMAN',
    LanguageName: 'Romanian',
  },
  {
    LanguageCode: 'RUSSI',
    LanguageName: 'Russian',
  },
  {
    LanguageCode: 'SAMOA',
    LanguageName: 'Samoan',
  },
  {
    LanguageCode: 'SERBI',
    LanguageName: 'Serbian',
  },
  {
    LanguageCode: 'SETSW',
    LanguageName: 'Setswana (alt Tswana)',
  },
  {
    LanguageCode: 'SGAW',
    LanguageName: "S'gaw Karen",
  },
  {
    LanguageCode: 'SHAN',
    LanguageName: 'Shanghai (Dialect of Wu Chinese)',
  },
  {
    LanguageCode: 'SHONA',
    LanguageName: 'Shona (alt Chishona)',
  },
  {
    LanguageCode: 'SINDH',
    LanguageName: 'Sindhi',
  },
  {
    LanguageCode: 'SINHA',
    LanguageName: 'Sinhalese',
  },
  {
    LanguageCode: 'SLOVA',
    LanguageName: 'Slovak',
  },
  {
    LanguageCode: 'SLOVE',
    LanguageName: 'Slovene',
  },
  {
    LanguageCode: 'SOMAL',
    LanguageName: 'Somali',
  },
  {
    LanguageCode: 'KURDS',
    LanguageName: 'Sorani Kurdish (alt Central Kurdish)',
  },
  {
    LanguageCode: 'SOTHO',
    LanguageName: 'Southern Sotho [Lesotho]',
  },
  {
    LanguageCode: 'SPANI',
    LanguageName: 'Spanish',
  },
  {
    LanguageCode: 'SWAHI',
    LanguageName: 'Swahili (alt Ki-Swahili)',
  },
  {
    LanguageCode: 'SWEDI',
    LanguageName: 'Swedish',
  },
  {
    LanguageCode: 'TAJIK',
    LanguageName: 'Tajiki (alt Tajik)',
  },
  {
    LanguageCode: 'TAMIL',
    LanguageName: 'Tamil',
  },
  {
    LanguageCode: 'TARTA',
    LanguageName: 'Tatar',
  },
  {
    LanguageCode: 'TELUG',
    LanguageName: 'Telugu',
  },
  {
    LanguageCode: 'TETUM',
    LanguageName: 'Tetun (alt Tetum)',
  },
  {
    LanguageCode: 'THAI',
    LanguageName: 'Thai',
  },
  {
    LanguageCode: 'TIGRI',
    LanguageName: 'Tigrinya',
  },
  {
    LanguageCode: 'TONGA',
    LanguageName: 'Tongan',
  },
  {
    LanguageCode: 'TSONG',
    LanguageName: 'Tsonga',
  },
  {
    LanguageCode: 'TURKI',
    LanguageName: 'Turkish',
  },
  {
    LanguageCode: 'TURKM',
    LanguageName: 'Turkmen',
  },
  {
    LanguageCode: 'UKRAI',
    LanguageName: 'Ukrainian',
  },
  {
    LanguageCode: 'URDU',
    LanguageName: 'Urdu',
  },
  {
    LanguageCode: 'UIGHU',
    LanguageName: 'Uyghur (alt Uighur)',
  },
  {
    LanguageCode: 'UZBEK',
    LanguageName: 'Uzbek',
  },
  {
    LanguageCode: 'VIETN',
    LanguageName: 'Vietnamese',
  },
  {
    LanguageCode: 'WELSH',
    LanguageName: 'Welsh',
  },
  {
    LanguageCode: 'XHOSA',
    LanguageName: 'Xhosa',
  },
  {
    LanguageCode: 'YORUB',
    LanguageName: 'Yoruba [Nigeria]',
  },
  {
    LanguageCode: 'ZULU',
    LanguageName: 'Zulu',
  },
];
